import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'PlasmidShapeBox',
  setup(__props) {

const rootEl = ref<HTMLDivElement>();
const isPlasmidVisible = ref(false);
onMounted(() => {
  const decorationObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          isPlasmidVisible.value = true;
        } else {
          isPlasmidVisible.value = false;
        }
      });
    },
    { threshold: 0.1 }
  );

  if (rootEl.value) {
    decorationObserver.observe(rootEl.value);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.section),
    ref_key: "rootEl",
    ref: rootEl
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.main),
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.$style.bar, _ctx.$style.bar1, isPlasmidVisible.value && _ctx.$style.plasmidAnimated]),
        style: {"--delay":"0.04s"}
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.$style.bar, _ctx.$style.bar2, isPlasmidVisible.value && _ctx.$style.plasmidAnimated]),
        style: {"--delay":"0.12s"}
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.$style.bar, _ctx.$style.bar3, isPlasmidVisible.value && _ctx.$style.plasmidAnimated]),
        style: {"--delay":"0.2s"}
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.$style.bar, _ctx.$style.bar4, isPlasmidVisible.value && _ctx.$style.plasmidAnimated]),
        style: {"--delay":"0.28s"}
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.$style.bar, _ctx.$style.bar5, isPlasmidVisible.value && _ctx.$style.plasmidAnimated]),
        style: {"--delay":"0.36s"}
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.$style.bar, _ctx.$style.bar6, isPlasmidVisible.value && _ctx.$style.plasmidAnimated]),
        style: {"--delay":"0.44s"}
      }, null, 2)
    ], 2)
  ], 2))
}
}

})